import React, { useEffect, useState } from 'react';
import WorkShopViewDetails from '../../../common/workshop/WorkShopViewDetails';
import AdminLayout from '../../../../layouts/AdminLayout';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWorkshopeDetailsById } from '../../../../redux/features/coach/actions/coachAction';
import Loader from '../../../../components/loader';

const WorkShopDetails = () => {
    const { state } = useLocation();
    const dispatch = useDispatch();
    const { isLoading2, workshopDetail } = useSelector((state) => state.coach.coach);
    const location = window?.location?.search?.split("=")[1];
    const [workShopData, setWorkShopData] = useState({
        data: {}
    });

    useEffect(() => {
        let data =
            workshopDetail && Object.keys(workshopDetail).length > 0
                ? workshopDetail
                : state?.data;
        setWorkShopData(prev => ({
            ...prev,
            data: data
        }));
    }, [workshopDetail]);

    useEffect(() => {
        window.scroll(0, 0);
        dispatch(fetchWorkshopeDetailsById({ payload: location }));
    }, []);

    if (isLoading2) {
        return <Loader />;
    };
    return (
        <AdminLayout>
            <WorkShopViewDetails state={workShopData} />
        </AdminLayout >
    )
};

export default WorkShopDetails;